import React,{useId} from 'react';
import './OperationCategoryAlert.css';
export function categoryDifference(recorded,current){
 if(!recorded||!Array.isArray(current))return '';
 const normalize=v=>String(v).trim().toUpperCase();
 if(current.some(c=>normalize(c)===normalize(recorded)))return '';
 return `La operación se registró con categoría ${recorded}. Las categorías actualmente asignadas son ${current.length?current.join(' / '):'ninguna'}. La asignación pudo ser diferente en ese mes. Se conservan la categoría y el importe registrados, sin recalcularlos.`;
}
export default function OperationCategoryAlert({recorded,current}){
 const id=useId(),message=categoryDifference(recorded,current);
 if(!message)return null;
 return <span className="operation-category-alert" tabIndex={0} role="img" aria-label="Diferencia de categoría" aria-describedby={id} title={message}><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path d="M12 3 2 21h20L12 3Z"/><path d="M12 9v5m0 3v1"/></svg><span id={id} role="tooltip">{message}</span></span>;
}
